import { Directive, ElementRef, Inject, Input, OnChanges, Optional, Renderer2 } from '@angular/core';
import { OpenWindowProvider, TypedChanges } from '@platform-frontend/util';

@Directive({
  selector: '[yatExternalLink]',
  exportAs: 'yatExternalLink'
})
export class ExternalLinkDirective implements OnChanges {
  constructor(
    private element: ElementRef<HTMLElement>,
    @Optional() @Inject(OpenWindowProvider) private openWindowProvider: string | null,
    private renderer: Renderer2
  ) {}

  @Input('yatExternalLink')
  url?: string | null;

  ngOnChanges(changes: TypedChanges<ExternalLinkDirective>): void {
    if (changes.url) {
      if (this.url) {
        this.renderer.setAttribute(this.element.nativeElement, 'href', this.url);
        this.renderer.setAttribute(this.element.nativeElement, 'target', '_blank');
        if (this.openWindowProvider) {
          this.renderer.setAttribute(this.element.nativeElement, 'onclick', `${this.openWindowProvider}('${this.url}'); event.preventDefault()`);
        }
      } else {
        this.renderer.removeAttribute(this.element.nativeElement, 'href');
        this.renderer.removeAttribute(this.element.nativeElement, 'target');
        this.renderer.removeAttribute(this.element.nativeElement, 'onclick');
      }
    }
  }
}
